import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useAppRoutes, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const CurrencyRatesViewChunk = lazy(() =>
  import('../feature-sets/CurrencyRatesView').then(({ CurrencyRatesView }) => ({
    default: CurrencyRatesView,
  }))
)

export const ManageCurrencyRatesPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.manageCurrencyRatesTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          name: intl.formatMessage(messages.manageCurrencyRatesTitle),
        },
      ]}
    >
      <CurrencyRatesViewChunk />
    </Page>
  )
}
